import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import getters from './getter'
import * as actions from './action'

Vue.use( Vuex );

//state
export const state = {
  customLang: 'hk',
  defaultLang: 'hk',
  langList: [],
  isLoadingShow: true
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
});